export default{
    与我们联系:"참여 신청하기",
    专属客户经理将尽快联系您:"",
    立即参与:"제출하기",
}